export const copyToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard
      .writeText(text)
      .then(() => {
        return "Code copied to clipboard!";
      })
      .catch(() => {
        throw new Error("Failed to copy!");
      });
  } else {
    // Fallback for older browsers or unsupported environments
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; // Prevents scrolling
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      return "Code copied to clipboard!";
    } catch (err) {
      throw new Error("Failed to copy!");
    } finally {
      document.body.removeChild(textArea);
    }
  }
};
